import React, { useEffect, useState } from "react";
import { ArrowRight, ShieldCheck, ExternalLink } from "lucide-react";

const CHECKOUT_URL = "https://jjmediagroup.online/clients/index.php?rp=/store/live-action-service-sv";

const Checkout = () => {
  const [seconds, setSeconds] = useState(4);

  useEffect(() => {
    if (seconds <= 0) {
      window.location.href = CHECKOUT_URL;
      return;
    }
    const timer = setTimeout(() => setSeconds((s) => s - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds]);

  return (
    <div className="py-24 bg-white min-h-[70vh]">
      <div className="max-w-md mx-auto px-5 text-center">
        <div className="w-16 h-16 rounded-full bg-p3-blue/10 flex items-center justify-center mx-auto mb-6">
          <ShieldCheck size={30} className="text-p3-blue" />
        </div>
        <h1 className="font-heading font-extrabold text-2xl text-p3-navy mb-3">Taking you to secure checkout</h1>
        <p className="text-sm text-p3-muted mb-2">
          You&apos;ll be redirected to our secure order form in {seconds}s.
        </p>
        <p className="text-xs text-p3-muted mb-8">
          Our checkout is hosted on a secure, encrypted third-party platform to process your order.
        </p>
        <a
          href={CHECKOUT_URL}
          className="inline-flex items-center gap-2 bg-p3-gold hover:bg-p3-gold/90 text-p3-navy font-semibold px-8 py-3.5 rounded-lg transition-all"
        >
          Continue to Checkout <ArrowRight size={16} />
        </a>
        <p className="text-xs text-p3-muted mt-6">
          Opening in the wrong place?{" "}
          <a
            href={CHECKOUT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-p3-blue font-semibold underline inline-flex items-center gap-1"
          >
            Open in a new tab <ExternalLink size={12} />
          </a>
        </p>
      </div>
    </div>
  );
};

export default Checkout;


